/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateIngestionSettingsMutationRequest,
  UpdateIngestionSettingsMutationResponse,
} from "../types/UpdateIngestionSettings.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateIngestionSettingsMutationKey = () =>
  [{ url: "/v1/client-settings/update-ingestion-settings" }] as const

export type UpdateIngestionSettingsMutationKey = ReturnType<
  typeof updateIngestionSettingsMutationKey
>

/**
 * @description Update ingestion settings
 * {@link /v1/client-settings/update-ingestion-settings}
 */
export async function updateIngestionSettings(
  data: UpdateIngestionSettingsMutationRequest,
  config: Partial<RequestConfig<UpdateIngestionSettingsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateIngestionSettingsMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateIngestionSettingsMutationRequest
  >({
    method: "POST",
    url: `/v1/client-settings/update-ingestion-settings`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateIngestionSettingsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateIngestionSettingsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateIngestionSettingsMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateIngestionSettingsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateIngestionSettingsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateIngestionSettings(data, config)
    },
  })
}

/**
 * @description Update ingestion settings
 * {@link /v1/client-settings/update-ingestion-settings}
 */
export function useUpdateIngestionSettings<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateIngestionSettingsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateIngestionSettingsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateIngestionSettingsMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateIngestionSettingsMutationKey()

  const baseOptions = updateIngestionSettingsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateIngestionSettingsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateIngestionSettingsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateIngestionSettingsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateIngestionSettingsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateIngestionSettingsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateIngestionSettingsMutationRequest },
    TContext
  >
}
